import { isTicketsMockEnabled } from '@/app/consts/featureFlags';
import { getProjectEnvVariables } from '@/shared/projectEnvVariables';

export const isChatwootConfigured = (): boolean => {
  const { VITE_APP_CHATWOOT_BASE_URL, VITE_APP_CHATWOOT_INBOX_IDENTIFIER } = getProjectEnvVariables().envVariables;
  return Boolean(VITE_APP_CHATWOOT_BASE_URL && VITE_APP_CHATWOOT_INBOX_IDENTIFIER) && !isTicketsMockEnabled();
};
